module.exports = __webpack_public_path__ + "static/media/white-label-guides-feature.a3777c6b.png";